var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPreventiveMaintenance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M5.9 11.5c-.3 0-.5-.2-.5-.5V7c0-.7.5-1.2 1.2-1.2h9.2c.7 0 1.2.6 1.2 1.2v1c0 .3-.2.5-.5.5S16 8.3 16 8V7c0-.1-.1-.2-.2-.2H6.6c-.1 0-.2.1-.2.2v4c0 .2-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M13.5 6.8c-.3 0-.5-.2-.5-.5V3.7H9.4v2.6c0 .3-.2.5-.5.5s-.5-.2-.5-.5V3.7c0-.5.4-1 .8-1h4c.5 0 .8.4.8 1v2.6c0 .3-.2.5-.5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M14.9 21.2c-.1 0-.2 0-.2-.1-.2-.1-.3-.4-.2-.7l2.7-5.3c.1-.2.4-.3.7-.2.2.1.3.4.2.7l-2.7 5.3c-.1.2-.3.3-.5.3M6.8 21.2c-.2 0-.4-.1-.5-.3L3 12l7.5-3c.4-.2 1-.2 1.5 0l3.1 1.6c.2.1.3.4.2.7s-.4.3-.7.2l-3.1-1.6c-.2-.1-.5-.1-.8 0l-6.6 2.6 3 8q.15.45-.3.6c.1.1 0 .1 0 .1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M11.2 15.7c-.3 0-.5-.2-.5-.5V9.3c0-.3.2-.5.5-.5s.5.2.5.5v5.9c0 .3-.2.5-.5.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M13.7 23.3c-1 0-2.2-.3-3.4-1-2.8-1.8-5.6.6-5.8.7-.2.2-.5.1-.7-.1s-.1-.5.1-.7c0 0 3.6-2.9 6.9-.8 3.6 2.3 6.7-.6 6.8-.7.2-.2.5-.2.7 0s.2.5 0 .7c0 0-2 1.9-4.6 1.9"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "m18.4 16.7-.3-.2C14.3 13.9 14 8.9 14 8.7v-.4l4.5-1.5 4.4 1.4v.3c.5 5-4 7.7-4.2 7.9zM15 9.1c.1 1.1.8 4.5 3.4 6.4.9-.6 3.6-2.9 3.5-6.4L18.5 8z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M17.8 13.2 16.7 12c-.2-.2-.2-.5 0-.7s.5-.2.7 0l.5.5 2.4-1.9c.2-.2.5-.1.7.1s.1.5-.1.7z"
})));
export default SvgPreventiveMaintenance;